import React, { FunctionComponent } from 'react';
import { DatePicker, Input, Select, Select as SelectBR } from '@vwfs-bronson/bronson-react';
import { FieldInputProps, useFormikContext } from 'formik';
import { get } from 'lodash';
import { FormField } from '../../components/FormField/FormField';
import { MaskedTextFormField, masks } from '../../components/FormFields/MaskedTextFormField';
import { OptionsItem } from '../../services/common/miscUtils.types';
import { SearchedValues } from './subpages/utils/searchedValues.types';

interface Props {
  name: string;
  label?: any;
  required?: boolean;
  disabled?: any;
  count?: any;
  onButtonClick?: any;
  value?: any;
  onChangeFunction?: any;
  placeholder?: any;
  setFieldValue?: any;
  minDate?: any;
  maxDate?: any;
  list?: any;
  defaultValueLabel?: string;
}

interface PropsWithSalesPersons extends Props {
  salesPersons: any[];
}

export const DropdownSearchFields: FunctionComponent<Props> = ({ name, label, list, required, defaultValueLabel }) => {
  const listToRender = [{ label: defaultValueLabel || 'Sélectionner', value: '' }, ...list].filter(
    Boolean
  ) as OptionsItem[];

  return (
    <FormField
      required={required}
      type="select"
      name={name}
      labelText={label}
      render={(fieldProps) => (
        <SelectBR {...fieldProps}>
          {listToRender.map(({ label, value }) => (
            <SelectBR.Item key={`${label}${value}`} value={`${value}`}>
              {label}
            </SelectBR.Item>
          ))}
        </SelectBR>
      )}
    />
  );
};

export const DropdownTransfertPopup: FunctionComponent<PropsWithSalesPersons> = ({
  name,
  label,
  required,
  disabled,
  salesPersons,
  onChangeFunction,
}) => {
  return (
    <FormField
      required={required}
      type="select"
      name={name}
      labelText={label}
      render={(...fieldProps) => (
        <Select {...fieldProps} disabled={disabled || false} onChange={(event) => onChangeFunction(event.target.value)}>
          {salesPersons?.map(({ label, value }) => (
            <Select.Item key={`${label}${value}`} value={`${value}`}>
              {label}
            </Select.Item>
          ))}
        </Select>
      )}
    />
  );
};

interface SearchProps extends Partial<FieldInputProps<any>> {
  onSearch?: ((searchValue: { searchQuery: string }) => void) | undefined;
}

export const Search: FunctionComponent<SearchProps> = ({ onSearch, ...props }) => {
  const { values, setFieldValue } = useFormikContext<SearchedValues>();
  const searchValue = values.searchQuery ?? '';

  const handleInputChange = () => {
    onSearch?.({ searchQuery: searchValue });
  };

  return (
    <Input
      {...props}
      addonElement="button"
      addonClickHandler={handleInputChange}
      noBackground
      addonIcon="semantic-search"
      addonText="search"
      value={searchValue}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue('searchQuery', event.target.value);
        props?.onChange?.(event);
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          handleInputChange();
        }
      }}
    />
  );
};

export const ActivationLicenseField: FunctionComponent<Props> = ({ name, label, required, placeholder, disabled }) => {
  return (
    <MaskedTextFormField
      fieldName={name}
      labelTranslationKey={label}
      mask={masks.licensePlateMask}
      placeholder={placeholder || 'AB-123-CD'}
      optional={!required}
      centerText
      isDisabled={disabled}
    />
  );
};

export const ActivationDatePicker: FunctionComponent<Props> = ({
  name,
  label,
  required,
  placeholder,
  minDate,
  maxDate,
  disabled,
}) => {
  const { setFieldValue, values } = useFormikContext<any>();
  return (
    <FormField
      name={name}
      type="other"
      labelText={label}
      required={required}
      disabled={disabled}
      render={(fieldProps) => (
        <DatePicker
          {...fieldProps}
          name={name}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          dateFormat="d/m/Y"
          locale="fr"
          placeholder={placeholder}
          mode="single"
          value={get(values, name, '')}
          onChange={(e) => setFieldValue(name, e)}
          onBlur={(e) => setFieldValue(name, e)}
        />
      )}
    />
  );
};
